import axios from "axios";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const GET_PLAN_DETAILS_REQUEST = "GET_PLAN_DETAILS_REQUEST";
export const GET_PLAN_DETAILS_SUCCESS = "GET_PLAN_DETAILS_SUCCESS";
export const GET_PLAN_DETAILS_FAILURE = "GET_PLAN_DETAILS_FAILURE";

export const MAKE_PAYMENT_REQUEST = "MAKE_PAYMENT_REQUEST";
export const MAKE_PAYMENT_SUCCESS = "MAKE_PAYMENT_SUCCESS";
export const MAKE_PAYMENT_FAILURE = "MAKE_PAYMENT_FAILURE";

export const SET_PLAN_EXPIRY_REQUEST = "SET_PLAN_EXPIRY_REQUEST";
export const SET_PLAN_EXPIRY_SUCCESS = "SET_PLAN_EXPIRY_SUCCESS";
export const SET_PLAN_EXPIRY_FAILURE = "SET_PLAN_EXPIRY_FAILURE";

export const GET_COMPARISON_FEATURES_REQUEST = "GET_COMPARISON_FEATURES_REQUEST";
export const GET_COMPARISON_FEATURES_SUCCESS = "GET_COMPARISON_FEATURES_SUCCESS";
export const GET_COMPARISON_FEATURES_FAILURE = "GET_COMPARISON_FEATURES_FAILURE";

export const CHECK_COUPON_CODE_REQUEST = "CHECK_COUPON_CODE_REQUEST";
export const CHECK_COUPON_CODE_SUCCESS = "CHECK_COUPON_CODE_SUCCESS";
export const CHECK_COUPON_CODE_FAILURE = "CHECK_COUPON_CODE_FAILURE";

export const PAYMENT_INTENT_REQUEST = "PAYMENT_INTENT_REQUEST";
export const PAYMENT_INTENT_SUCCESS = "PAYMENT_INTENT_SUCCESS";
export const PAYMENT_INTENT_FAILURE = "PAYMENT_INTENT_FAILURE";

export const CLEAR_PAYMENT_INTENT = "CLEAR_PAYMENT_INTENT";

export const getPlans = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PLAN_DETAILS_REQUEST });
      const url = `${BASE_URL}/plan/get/list/v1`;
      const response = await axios.get(url);
      dispatch({ type: GET_PLAN_DETAILS_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_PLAN_DETAILS_FAILURE, payload: error.message });
    }
  };
};

export const setPlanExpiry = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_PLAN_EXPIRY_REQUEST });
      const url = `${BASE_URL}/plan/update/subscriber/status/v1`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: SET_PLAN_EXPIRY_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: SET_PLAN_EXPIRY_FAILURE, payload: error.message });
    }
  };
};

export const makePaymentOLd = (data, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MAKE_PAYMENT_REQUEST });

      // const urlForPublish = `${BASE_URL}/stripe/get/publish/key/v1`;
      // const getPublishKey = await axios.get(urlForPublish, {
      //   headers: {
      //     Authorization: localStorage.getItem("token"),
      //     "Content-Type": "application/json",
      //   },
      // });
      const stripe = await loadStripe(
        process.env.REACT_APP_STRIPE_PUBLISHER_KEY
      );

      const url = `${BASE_URL}/plan/create/checkout/session/v1`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });

      const result = await stripe.redirectToCheckout({
        sessionId: response.data.id,
      });

      if (result.error) {
        console.log(result.error);
      }

      dispatch({ type: MAKE_PAYMENT_SUCCESS, payload: result });
    } catch (error) {
      console.error(error);
      if (!localStorage.getItem("token")) {
        toast.error("Please Login!!");
        navigate("/login");
      }
      dispatch({ type: MAKE_PAYMENT_FAILURE, payload: error.message });
    }
  };
};

export const getComparisonFeatures = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_COMPARISON_FEATURES_REQUEST });
      const url = `${BASE_URL}/plan/get/comparison/features/v1`;
      const response = await axios.get(url);
      dispatch({ type: GET_COMPARISON_FEATURES_SUCCESS, payload: response.data });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_COMPARISON_FEATURES_FAILURE, payload: error.message });
    }
  };
};

export const checkCouponCode = (code, setAppliedDiscount) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CHECK_COUPON_CODE_REQUEST });
      const url = `${BASE_URL}/promocode/validate-coupon/v1`;
      const response = await axios.post(url, { code }, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch({ type: CHECK_COUPON_CODE_SUCCESS, payload: response.data });
    } catch (error) {
      setAppliedDiscount(null);
      toast.error("The discount code you entered is expired or doesn’t exist");
      dispatch({ type: CHECK_COUPON_CODE_FAILURE, payload: error.message });
    }
  };
};

export const createPaymentIntent = (data, navigate, setAppliedDiscount, setDiscountCode) => {
  return async (dispatch) => {
    try {
      dispatch({ type: PAYMENT_INTENT_REQUEST });

      const url = `${BASE_URL}/plan/create/subscription/v1`;
      const response = await axios.post(url, data, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });

      dispatch({ type: PAYMENT_INTENT_SUCCESS, payload: response.data });
    } catch (error) {
      setAppliedDiscount(null);
      setDiscountCode("");
      toast.error(error?.response?.data?.message || "Failed to create payment intent");
      if (!localStorage.getItem("token")) {
        toast.error("Please Login!!");
        navigate("/login");
      }
      dispatch({ type: PAYMENT_INTENT_FAILURE, payload: error.message });
    }
  };
};

export const clearPaymentIntent = () => ({
  type: CLEAR_PAYMENT_INTENT
});